import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { CONFIG } from 'src/config-global';
import { DashboardLayout } from 'src/layouts/dashboard';

import { LoadingScreen } from 'src/components/loading-screen';

import { AuthGuard } from 'src/auth/guard';
import { CompanyGuard } from 'src/auth/guard/company-guard';
import { EmployeeGuard } from 'src/auth/guard/employee-guard';

// ----------------------------------------------------------------------

const LibraryPage = lazy(() => import('src/pages/library'));

// ----------------------------------------------------------------------

const layoutContent = (
  <DashboardLayout>
    <Suspense fallback={<LoadingScreen />}>
      <Outlet />
    </Suspense>
  </DashboardLayout>
);

export const libraryRoutes = [
  {
    path: '/library',
    element: CONFIG.auth.skip
      ? <>{layoutContent}</>
      : <AuthGuard>
        <CompanyGuard>
          <EmployeeGuard>
            {layoutContent}
          </EmployeeGuard>
        </CompanyGuard>
      </AuthGuard>,
    children: [{ element: <LibraryPage />, index: true }],
  },
];
